import { UpdateProfileApi } from '../api';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { JTM } from '../utils';

export const handelUpdateProfileMethod = async (
    formRef: any,
    imageFile: any,
    setDisplayBtn: (bol: boolean) => void,
    setUserInfo:(obj:any)=>void ,
    navigate:(str: string) => void,
) => {
    try {
        let postData:any = {
            'birthday': `${formRef.current['year'].value}-${formRef.current['month'].value}-${formRef.current['day'].value}`,
            'fname': formRef.current['name'].value,
            'lname': formRef.current['family'].value,
        }
        if(imageFile != null){
            postData['avatar'] = imageFile == 'delete' ? null : imageFile ;
        }
        setDisplayBtn(true)
        let res = await UpdateProfileApi(postData)
        setDisplayBtn(false)
        if (res.data.status == 'OK') {
            setUserInfo(res?.data?.data?.[0])
            localStorage.setItem( 'user' , JSON.stringify(res?.data?.data?.[0]))
            toast(res.data.message, { type: "success" })
            setDisplayBtn(false)
            navigate('/p/record');
        }
        else {
            toast(res.data.message, { type: "error" })
            setDisplayBtn(false)
        }
    }
    catch (err: any) {
        setDisplayBtn(false)
    }
}

